import _ from 'lodash'
import {withActions} from 'carmi-host-extensions'
import {getRunUserFunctionMessage} from './messageBuilder'

export {dispatchName as name} from '../platform.schema'

export const defaultModel = {
    didStart: {}
}

function getEvent(event) {
    const result = _.merge(_.pick(event, 'item'), _.pickBy(event, _.negate(_.isObject)))
    result.nativeEvent = _.pickBy(event.nativeEvent, _.negate(_.isObject))
    if (event.data) {
        result.data = event.data
    }
    return result
}

const sendInitMessage = (wixCodeAppAPI, contextId, apps) => {
    const message = {
        type: 'wix_code_worker_init',
        id: contextId,
        apps
    }
    wixCodeAppAPI[contextId].sendMessage(message)
}

const sendStartMessage = (wixCodeAppAPI, contextId, contextModel) => {
    const message = {
        context: contextModel,
        type: 'wix_code_worker_start',
        id: contextId
    }
    wixCodeAppAPI[contextId].sendMessage(message)
}

export const functionLibrary = {
    startPlatformWorker: withActions((actions, contextId, getWixCodeAppAPI, contextModel, apps, didStart) => {
        if (didStart) {
            return contextModel
        }
        const wixCodeAppAPI = getWixCodeAppAPI()
        sendInitMessage(wixCodeAppAPI, contextId, apps)
        sendStartMessage(wixCodeAppAPI, contextId, contextModel)
        actions.setDidStart(contextId, true)
        return contextModel
    }),

    deleteIsStarted: withActions((actions, contextId) => {
        actions.setDidStart(contextId, undefined)
    }),

    sendRunCodeMessage: (getWixCodeAppAPI, behavior) => {
        const contextId = behavior.targetId
        const message = getRunUserFunctionMessage(contextId, behavior.params, getEvent(behavior.event))
        getWixCodeAppAPI()[contextId].sendMessage(message)
    },

    //TODO: we probably should batch the changes into less messages, this should be done here, in the runtime code (use weakMap)
    sendUpdateMessage: withActions((actions, val, getWixCodeAppAPI, didStart, fieldName, compId, contextId) => {
        if (didStart()) {
            const message = {
                contextId,
                intent: 'WIX_CODE',
                type: 'update',
                updates: {
                    [compId]: {
                        [fieldName]: val
                    }
                }
            }
            const wixCodeAppAPI = getWixCodeAppAPI()
            if (!wixCodeAppAPI[contextId]) {
                return null
            }
            wixCodeAppAPI[contextId].sendMessage(message)
        }
        return val
    })
}

